import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">内容导航</h2>
          <p className="text-sm text-foreground-500">九大内容板块，全面覆盖你的吃瓜需求</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#index"
              className="flex items-start gap-4 p-5 rounded-xl bg-background-50 hover:bg-background-100 border border-background-200 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 bg-background-100 group-hover:bg-background-200 transition-colors`}>
                <i className={`${item.icon} text-xl ${item.color}`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 flex items-center">
                <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}